// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-taxibox-storage-offer-tsx": () => import("./../../../src/pages/taxibox-storage-offer.tsx" /* webpackChunkName: "component---src-pages-taxibox-storage-offer-tsx" */),
  "component---src-templates-page-template-tsx": () => import("./../../../src/templates/page.template.tsx" /* webpackChunkName: "component---src-templates-page-template-tsx" */)
}

